import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import CompanyManageView from './CompanyManageView';

@inject('commonStore','companyStore')
@observer
class CompanyManageContainer extends Component {

  UNSAFE_componentWillMount() {
    this.props.companyStore.setCommonStoreInfo(this.props.commonStore);
    this.props.companyStore.onClear();

    this.props.companyStore.disCompanyList('T');
    this.props.companyStore.disCompanyList("M");
  }

  render() {
    const { sessionLoginInfo } = this.props.commonStore;
    return (
      <Fragment>
        <CompanyManageView 
          cGbn={sessionLoginInfo?.cGbn || "" }
        />
      </Fragment>
    );
  }

}

export default withRouter(CompanyManageContainer);
